import {
    columnChartConfig,
    EChartDisplayType,
    renderChangeLabelsHof,
} from "pro-features/components/Chart/src/configs/column-chart/columnChartConfig";
import type { ColumnChartData } from "pro-features/components/Chart/src/types";
import { CHART_HEIGHT } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/common/const";
import type { IChartState } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/common/types";
import { tooltipFormatterHof } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/size-and-growth-period-over-period/TooltipFormatter";
import { resolveMaxYaxisValue } from "pro-features/components/Chart/src/utils";
import { getCategoriesItems } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/common/utils/getCategoriesItems";

const LABEL_PADDINGS = {
    ABSOLUTE: 27,
};

const getChartConfig = (chartData: ColumnChartData = [], chartState: IChartState) => {
    const mainSeries = chartData[0];
    if (!mainSeries) {return {};}
    const { data: mainSeriesData = [] } = mainSeries;
    const columnChartConfigArgs = {
        categories: getCategoriesItems(mainSeriesData),
        maxPointWidth: 48,
        height: CHART_HEIGHT,
        chartDisplayType: EChartDisplayType.ABSOLUTE,
        tooltipFormatter: tooltipFormatterHof(chartState),
        maxYaxisValue: resolveMaxYaxisValue(mainSeriesData),
        renderCustomLabels: renderChangeLabelsHof(LABEL_PADDINGS.ABSOLUTE),
    };
    return columnChartConfig(columnChartConfigArgs);
};

export const getChartConfigHof =
    (chartState: IChartState) =>
    (chartData: ColumnChartData = []) =>
        getChartConfig(chartData, chartState);
